import { render, staticRenderFns } from "./detailInfo.vue?vue&type=template&id=3113d213"
import script from "./detailInfo.vue?vue&type=script&lang=js"
export * from "./detailInfo.vue?vue&type=script&lang=js"
import style0 from "./detailInfo.vue?vue&type=style&index=0&id=3113d213&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports